import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useActiveToolsMenuCardStyles = makeStyles(
  (theme: Theme) => ({
    menuContainer: {
      '& .MuiPaper-root, & .v5-MuiPaper-root': {
        borderRadius: '8px',
        boxShadow: 'none',
        background:
          theme.palette?.mode === 'dark'
            ? '#383838'
            : 'var(--xlrt-color-ui-gray95)',
        width: '208px',
        height: '180px',
        overflow: 'hidden',
        '& .MuiList-root, & .v5-MuiList-root': {
          padding: '0',
        },
        '& .MuiMenuItem-root, & .v5-MuiMenuItem-root': {
          display: 'flex',
          padding: '0.75rem 0.6rem',
          alignItems: 'center',
          gap: '8px',
          cursor: 'default',
          '&:hover': {
            backgroundColor:
              theme.palette?.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.5rem',
    },
    headerText: {
      fontSize: '0.75rem',
      fontWeight: 400,
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
      lineHeight: '150%',
    },
    closeIcon: {
      fontSize: '1.25rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
    },
    itemText: {
      fontSize: '0.75rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
      lineHeight: '150%',
      fontWeight: 400,
    },
    emptyText: {
      fontSize: '1rem',
      color:
        theme.palette?.mode === 'dark'
          ? 'var(--xlrt-color-ui-gray60)'
          : 'var(--xlrt-color-ui-gray20)',
      lineHeight: 'normal',
      fontWeight: 400,
      textAlign: 'center' as const,
      padding: '0.75rem 0.6rem',
    },
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.75rem 0.6rem',
      gap: '8px',
    },
    loadingText: {
      fontSize: '1rem',
      color: 'var(--xlrt-color-ui-gray60)',
      lineHeight: 'normal',
      fontWeight: 400,
    },
    toolsList: {
      maxHeight: 'calc(180px - 50px)',
      overflowY: 'auto' as const,
      '&::-webkit-scrollbar': {
        width: '6px',
        backgroundColor:
          theme.palette?.mode === 'dark'
            ? '#383838'
            : 'var(--xlrt-color-ui-gray95)',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor:
          theme.palette?.mode === 'dark'
            ? '#383838'
            : 'var(--xlrt-color-ui-gray95)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.grey[500],
        borderRadius: '10px',
        border: `2px solid ${
          theme.palette?.mode === 'dark'
            ? '#383838'
            : 'var(--xlrt-color-ui-gray95)'
        }`,
      },
    },
  }),
  { name: 'ActiveToolsMenuCard' },
);
